import Vue from 'vue';
import Router from 'vue-router';

const Home = () => import('@/views/Home');
const Login = () => import('@/views/Login');
const Story = () => import('@/views/Story');
const HistoricStory = () => import('@/views/HistoricStory');
const HistoricMirrorDetail = () => import('@/views/HistoricMirrorDetail');
const Mirror = () => import('@/views/Mirror');
const Admin = () => import('@/views/Admin');
const Callback = () => import('@/views/Callback');
const MirrorActivityDetail = () => import('@/views/MirrorActivityDetail');

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/story/:story_id',
    name: 'story',
    component: Story,
  },
  {
    path: '/storage/story/:story_id',
    name: 'historicStory',
    component: HistoricStory,
  },
  {
    path: '/storage/mirror/:place/:short_name',
    name: 'HistoricMirrorDetail',
    component: HistoricMirrorDetail,
  },
  {
    path: '/story-create/:place/:folder',
    name: 'storyCreation',
    component: Story,
  },
  {
    path: '/mirror/:place/:program_tag',
    name: 'mirror',
    component: Mirror,
  },
  {
    path: '/mirror/detail/:place/:program_tag',
    component: MirrorActivityDetail,
  },
  {
    path: '/admin',
    component: Admin,
  },
  {
    path: '/users/auth/callback',
    component: Callback,
  },
];

const router = new Router({
  mode: 'history',
  routes: routes,
});

router.beforeEach((to, from, next) => {
  const store = router.app.$options.store;
  const isLoggedIn = store.state.user.isLoggedIn;

  if (!isLoggedIn) {
    store.commit('CLEAR_CREDENTIALS');
  }
  store.dispatch('analyticsUpdateUserId');
  if (to.path === '/login' || to.path === '/users/auth/callback') {
    return next();
  } else if (!isLoggedIn) {
    store.dispatch('setInitialUrl', to.path);
    return next('/login');
  } else if (to.path === '/admin' && !store.state.user.currentUser.isAdmin) {
    return next('/');
  } else {
    next();
  }
});

export default router;
